export default {
  data: [
    {
      dairy: false,
      favorite: false,
      flavor: 'Aloe',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Coffee',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Green Apple',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Lychee',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Mango',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Passion Fruit',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Strawberry',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Three Color',
      premium: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/js/jelly_flavors.js